<template>
    <div :key="articleKey" v-if='user || $route.meta.isPublicView'>
        <va-page-header>

            <div slot="title">
                <va-button v-if="!$route.meta.isPublicView" class="back_button" @click.native="$router.go(-1)"
                    type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>
                <span>{{ getLabel }}</span><span v-if="!$route.meta.isPublicView" class='status'>{{
                    _(viewedSectionObject.get('status')) }}</span>
            </div>

            <div slot="actions" v-if="!$route.meta.isPublicView">

                <va-button size="lg"
                    v-if="viewedSectionObject.get('status') == 'pending' && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || isUserApprover)"
                    type="danger" @click.native="rejectObject">
                    {{ _('REJECT') }}
                </va-button>
                <va-button size="lg"
                    v-if="viewedSectionObject.get('status') == 'pending'  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || isUserApprover)"
                    type="info" @click.native="approveObject">
                    {{ _('APPROVE') }}
                </va-button>

                <va-button size="lg"
                    v-if="viewedSectionObject.get('status') == 'approved'  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor'))"
                    type="default" @click.native="updateShareWith">
                    {{ _('UPDATE') }}
                </va-button>

                <va-button size="lg"
                    v-if="viewedSectionObject.get('status') == 'approved'  && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')|| user.get('roles').includes(section + '-approver'))"
                    type="info" @click.native="openGenerateLink">
                    {{ _('SHARE') }}
                </va-button>
            </div>

        </va-page-header>

        <va-modal :title="_('Generate Link')" :width="'500px'" ref="generateLinkModal" :backdrop-clickable="true"
            @confirm="confirmLink">
            <div slot="body">
                <va-checkbox @change="generateLink" v-model="isGenerating" label="isGenerating">
                    {{ _('Generate Public link') }}</va-checkbox>
                <br>

                <va-checkbox-group v-model="selectedLinkParts" v-if="isGenerating" :vertical="true"
                    style="margin-top: 20px; margin-left: 20px">
                    <va-checkbox label="attachments" v-if="section == 'article'">
                        {{ _('Share attachments') }}</va-checkbox>
                    <va-checkbox label="description" v-if="section != 'article'">
                        {{ _('Share description') }}</va-checkbox>
                    <va-checkbox label="metaForm">{{ _('Share meta form') }}</va-checkbox>
                </va-checkbox-group>

                <div v-if="isGenerating" class="public_link">
                    <span style="border: 1px solid; border-radius: 5px; padding: 10px">{{ currentLink }}</span>
                    <!-- <va-tooltip :content="_('copy link')" placement="right" trigger="hover">
                        <va-icon type="copy" size="1.5em" color="gray" class="copy_link"
                            @click.native="copyLinkToClipboard">
                        </va-icon>
                    </va-tooltip> -->
                </div>

            </div>
        </va-modal>

        <va-row :gutter="42">
            <va-column :lg="9" :md="9" :sm="12" :xs="12">

                <div v-if="viewedSectionObject && section == 'article'">
                    <bdo :dir="getDirection">
                        <div class="description_container" style="width: 810px" v-html="getDescription"></div>
                    </bdo>
                    <hr>
                </div>

                <!-- geolocation -->
                <va-row :gutter="12" style="margin-top: 20px"
                    v-if="section == 'map' && viewedSectionObject.get('markers').length != 0">
                    <va-column :lg="12" :md="12" :sm="12" :xs="12">
                        <GmapMap :center="{lat:34.55, lng:69.20}" :zoom="6" map-type-id="terrain"
                            style="max-width: 715px;  height: 500px; padding: 0; margin: 0">
                            <GmapMarker :key="index" v-for="(m, index) in viewedSectionObject.get('markers')"
                                :position="m.position" @click="center=m.position" />
                        </GmapMap>

                    </va-column>
                </va-row>

                <div
                    v-if="section != 'file' && viewedSectionObject.get('attachments').length != 0  && isAttachmentsVisible">
                    <hr>
                    <p class="field_label">{{ _('attachments') }}</p>

                    <div v-for="file in viewedSectionObject.get('attachments')" @click="navigate(file)">
                        <img class="file_hover" style="max-width: 800px" v-if="getFileMainType(file) == 'image'"
                            :src="file" alt="">

                        <video v-else-if="getFileMainType(file) == 'video'" controls style="max-width: 800px">
                            <source :src="file">
                            Your browser does not support HTML5 video.else if (action == "attachmentRemove")
                            return "removed some attachments from" +
                            " " +
                            g_getLabel(activity) +
                            " " +
                            activity.get("type");
                        </video>

                        <object v-else-if="getFileMainType(file) == 'pdf'" :data="file" type="application/pdf"
                            width="800px" height="800px">
                            <p>No file available</p>
                        </object>

                        <va-tooltip v-else content="download" placement="right" trigger="hover">

                            <span v-if="user" class="file_download">
                                <va-icon size="10em" color="gray" type="file"
                                    @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                </va-icon>
                            </span>

                        </va-tooltip>
                    </div>
                </div>

                <div v-else-if="section == 'file'">
                    <img class="file_hover" style="max-width: 800px"
                        v-if="getFileMainType(viewedSectionObject.get('attachments')) == 'image'"
                        :src="viewedSectionObject.get('attachments')" alt="">

                    <video v-else-if="getFileMainType(viewedSectionObject.get('attachments')) == 'video'" controls
                        style="max-width: 800px">
                        <source :src="viewedSectionObject.get('attachments')">
                        Your browser does not support HTML5 video.
                    </video>

                    <object v-else-if="getFileMainType(viewedSectionObject.get('attachments')) == 'pdf'"
                        :data="viewedSectionObject.get('attachments')" type="application/pdf" width="800px"
                        height="800px">
                        <p>No file available</p>
                    </object>

                    <va-tooltip v-else content="download" placement="right" trigger="hover">

                        <span v-if="user" class="file_download">
                            <va-icon size="10em" color="gray" type="file"
                                @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + viewedSectionObject.get('attachments')})">
                            </va-icon>
                        </span>
                    </va-tooltip>
                </div>
            </va-column>
            <va-column v-show="viewedSectionObject" :lg="3" :md="3" :sm="12" :xs="12"
                style="background:#dbdcdf33; padding:0; padding-bottom:20px;">
                <div style="justify-content:space-between; display:flex; margin-top:14px">
                    <va-button type="default" style="padding:0 20px; background:#dbdcdf77"
                        @click.native="() => selectedLang = 'english'">
                        English
                    </va-button>
                    <va-button type="default" style="padding:0 20px; background:#dbdcdf77"
                        @click.native="() => selectedLang = 'pashto'">
                        پښتو
                    </va-button>
                    <va-button type="default" style="padding:0 20px; background:#dbdcdf77"
                        @click.native="() => selectedLang = 'dari'">
                        دری
                    </va-button>

                </div>
                <h3
                    style="font-size:.8em; color:#333 !important;background: #fffa; border-bottom: 1px solid #eee; padding:8px; text-align: cen/ter;  margin-bottom: 20px;">
                    {{ getInformationLabel }}
                </h3>

                <div>
                    <span class="field_label" v-if="viewedSectionObject">{{ getDateLabel }} (Y-M-D):</span>
                    <span class="field-value">{{ new Date(viewedSectionObject.createdAt).getFullYear() + '-' + parseInt(1 +
                        new
                        Date(viewedSectionObject.createdAt).getMonth())+ '-' + new
                        Date(viewedSectionObject.createdAt).getDate() }}</span>
                </div>
                <br>

                <div v-if="viewedSectionObject.get('approvalBy') && !$route.meta.isPublicView">
                    <span class="field_label" v-if="viewedSectionObject">{{ getApprovalByLabel }}:</span>
                    <span class="field-value">{{ viewedSectionObject.get('approvalBy').get('name') }}</span>
                </div>

                <div v-if="section != 'article' && isDescriptionVisible">
                    <span class="field_label" v-if="viewedSectionObject">{{ _('Description') }}:</span>
                    <bdo :dir="getDirection">
                        <span class="field-value">{{ getDescription }}</span>
                    </bdo>

                </div>
                <br>

                <div v-if="isAttachmentsVisible">
                    <div style="display:flex; flex-direction: column">

                        <div style="display:flex; flex-direction: column">
                            <div class="file_chip"
                                v-if="section == 'file' && viewedSectionObject.get('attachments') != ''">
                                <span class="file-text file_view">{{
                                    viewedSectionObject.get('attachments').split('/')[viewedSectionObject.get('attachments').split('/').length
                                    -1]
                                    }}</span>
                                <!-- <a target="_blank" class="file_download" :href="viewedSectionObject.get('attachments')">
                                    <va-icon class="file_download_icon" type="download" size=".8em"></va-icon>
                                </a> -->
                                <!-- <span v-if="user" class="file_download">
                                    <va-icon class="file_download_icon" type="download" size=".8em"
                                        @click.native="sendEmail({from: 'neis@nepa.gov.af', to: user.get('username'), subject: 'Attachment fb', text: viewedSectionObject.get('attachments')})">
                                    </va-icon>
                                </span> -->

                                <span v-if="user" class="file_download">
                                    <va-icon class="file_download_icon" type="download" size=".8em"
                                        @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + viewedSectionObject.get('attachments')})">
                                    </va-icon>
                                </span>

                            </div>

                            <div
                                v-else-if="(section == 'article' || section == 'map') && viewedSectionObject.get('attachments').length != 0">
                                <div class="file_chip" v-for="file in viewedSectionObject.get('attachments')">
                                    <span class="file-text file_view">{{
                                        file.split('/')[file.split('/').length
                                        -1]
                                        }}</span>
                                    <!-- <a target="_blank" class="file_download" :href="file">
                                        <va-icon class="file_download_icon" type="download" size=".8em"></va-icon>
                                    </a> -->
                                    <span v-if="user" class="file_download">
                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                        </va-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h3 v-if="isMetaFormVisible"
                    style="font-size:.8em; color:#333 !important;background: #fffa; border-bottom: 1px solid #eee; padding:8px; text-align: cen/ter; margin-bottom: 20px; margin-top:40px;">
                    {{ getMetaDataLabel }}</h3>
                <div v-if="selectedLang == 'english' && viewedSectionObject.get('meta_form_english') != ''"
                    name="English">
                    <div v-for="prop in meta_data_props" v-if="isMetaFormVisible">
                        <va-row :gutter="12" style="margin: 0">
                            <va-column :md="8">
                                <span class="field_label">
                                    {{ getFieldLabel(prop.name) }}
                                </span>
                                <span class="field-value"
                                    v-if="prop.type != 'text' && prop.type != 'textarea' && prop.type != 'attachment' && prop.type != 'single-geolocation' && prop.type != 'multiple-geolocation'">{{
                                                getValue(prop) }}</span>
                                <bdo :dir="getDirection"
                                    v-if="prop.type == 'text' || prop.type == 'textarea'"><span>{{getValue(prop)}}</span></bdo>
                                <div v-if="prop.type == 'single-geolocation' || prop.type == 'multiple-geolocation'">
                                    <GmapMap :center="{lat:34.55, lng:69.20}" :zoom="5" map-type-id="terrain"
                                        style="max-width:600px; width: 200px;  height: 200px; padding: 0; margin: 0">
                                        <GmapMarker v-if="prop.type == 'multiple-geolocation'" :key="index"
                                            v-for="(m, index) in getValue(prop)" :position="m.position"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                        <GmapMarker v-if="prop.type=='single-geolocation'" :position="prop.value"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                    </GmapMap>
                                    <br>
                                </div>
                                <div v-if="prop.type == 'attachment'">
                                    <div v-if="Array.isArray(prop.value)">
                                        <div v-for="(file, index) in prop.value"
                                            style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                                    getFileName(file)
                                                                    }}</span>
                                                    <!-- :href="file" :download="file" -->
                                                    <!-- <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({from: 'neis@nepa.gov.af', to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: file})">
                                                        </va-icon>
                                                    </span> -->
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                        </va-icon>
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                                    getFileName(prop.value)
                                                                    }}</span>
                                                    <!-- <a class="file_download" :href="prop.value" :download="prop.value">
                                                        <va-icon class="file_download_icon" type="download" size=".8em">
                                                        </va-icon>
                                                    </a> -->
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({from: 'neis@nepa.gov.af', to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: prop.value})">
                                                        </va-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </va-column>
                        </va-row>
                    </div>
                </div>

                <div v-if="selectedLang == 'pashto' && viewedSectionObject.get('meta_form_pashto') != ''" name="پښتو">
                    <div v-for="prop in propsPashto" v-if="isMetaFormVisible">
                        <va-row :gutter="12" style="margin: 0">
                            <va-column :md="8">
                                <span class="field_label">
                                    {{ getFieldLabel(prop.name) }}
                                </span>
                                <span class="field-value"
                                    v-if="prop.type != 'attachment' && prop.type != 'single-geolocation' && prop.type != 'multiple-geolocation'">{{
                                                getValue(prop) }}</span>
                                <div v-if="prop.type == 'single-geolocation' || prop.type == 'multiple-geolocation'">
                                    <GmapMap :center="{lat:34.55, lng:69.20}" :zoom="5" map-type-id="terrain"
                                        style="max-width:600px; width: 200px;  height: 200px; padding: 0; margin: 0">
                                        <GmapMarker v-if="prop.type == 'multiple-geolocation'" :key="index"
                                            v-for="(m, index) in getValue(prop)" :position="m.position"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                        <GmapMarker v-if="prop.type=='single-geolocation'" :position="prop.value"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                    </GmapMap>
                                    <br>
                                </div>
                                <div v-if="prop.type == 'attachment'">
                                    <div v-if="Array.isArray(prop.value)">
                                        <div v-for="(file, index) in prop.value"
                                            style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                                    getFileName(file)
                                                                    }}</span>
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                        </va-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                        getFileName(file)
                                                        }}</span>
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                        </va-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </va-column>
                        </va-row>
                    </div>
                </div>

                <div v-if="selectedLang == 'dari' && viewedSectionObject.get('meta_form_dari') != ''" name="دری">
                    <div v-for="prop in propsDari" v-if="isMetaFormVisible">
                        <va-row :gutter="12" style="margin: 0">
                            <va-column :md="8">
                                <span class="field_label">
                                    {{ getFieldLabel(prop.name) }}
                                </span>
                                <span class="field-value"
                                    v-if="prop.type != 'attachment' && prop.type != 'single-geolocation' && prop.type != 'multiple-geolocation'">{{
                                                getValue(prop) }}</span>
                                <div v-if="prop.type == 'single-geolocation' || prop.type == 'multiple-geolocation'">
                                    <GmapMap :center="{lat:34.55, lng:69.20}" :zoom="5" map-type-id="terrain"
                                        style="max-width:600px; width: 200px;  height: 200px; padding: 0; margin: 0">
                                        <GmapMarker v-if="prop.type == 'multiple-geolocation'" :key="index"
                                            v-for="(m, index) in getValue(prop)" :position="m.position"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                        <GmapMarker v-if="prop.type=='single-geolocation'" :position="prop.value"
                                            :clickable="true" :draggable="true" @click="center=m.position" />
                                    </GmapMap>
                                    <br>
                                </div>
                                <div v-if="prop.type == 'attachment'">
                                    <div v-if="Array.isArray(prop.value)">
                                        <div v-for="(file, index) in prop.value"
                                            style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                        getFileName(file)
                                                        }}</span>
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                        </va-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div style="display: flex; flex-direction: row; margin-right: 8px; ">
                                            <div style="display:flex; flex-direction: column">
                                                <div class="file_chip">
                                                    <span class="file-text file_view">{{
                                                        getFileName(file)
                                                        }}</span>
                                                    <span v-if="user" class="file_download">
                                                        <va-icon class="file_download_icon" type="download" size=".8em"
                                                            @click.native="sendEmail({to: user.get('username'), subject: sectionCapitalized + ': ' + getLabel + ', attachment download', text: 'You can download the requested attachment from this link: ' + file})">
                                                        </va-icon>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </va-column>
                        </va-row>
                    </div>
                </div>
            </va-column>

        </va-row>

        <br>

        <div v-if="user && !$route.meta.isPublicView">
            <va-row
                v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')"
                :gutter="12">
                <va-column :lg="12" :md="12" :sm="12" :xs="12" style="margin-top: 10px">
                    <va-card :elevation="2" :padding="10" style="padding: 10px">
                        <user-selection v-bind:selected.sync="sharedWith" :showRequired="false"
                            :title="_('Share With Guests')" :roles="['guest']" :disable="false" :hasData="true" />
                    </va-card>
                </va-column>
            </va-row>

            <hr>

            <va-row v-if="!user.get('roles').includes('guest') && !$route.meta.isPublicView" :gutter="42">
                <va-column :lg="12" :md="12" :sm="12" :xs="12">
                    <div>
                        <activities />
                    </div>
                </va-column>
            </va-row>
        </div>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapActions, mapGetters } from 'vuex';
    import Activities from './Activities.vue'
    import UserSelection from "./UserSelection.vue"
    export default {

        components: {
            Activities,
            UserSelection
        },

        data() {
            return {
                articleName: '',
                articleNamePashto: '',
                articleNameDari: '',
                selectedType: null,
                articleDescription: '',
                articleDate: '',
                selectedFile: null,
                uploadingLoader: false,
                progressText: '',
                parentRoute: '',
                viewedSectionObject: { get: () => '' },
                viewedSectionObjectMime: '',
                viewedSectionObjectSize: 0,
                metaForms: [],
                selectedMetaForm: '',
                selectedLang: '',
                targetMetaForm: {},
                theVars: {},
                selectedFiles: [],
                metaFormSelectedFiles: [],
                loading: false,
                metaFormSubmmittedResponseId: '',
                meta_data_props: [],
                propsPashto: [],
                propsDari: [],
                fields: {},
                articleAttachments: [],
                requireArticleApproval: false,
                articleKey: '',
                articleStatus: '',
                sectionCapitalized: '',
                section: '',
                selectedLinkParts: ['attachments', 'metaForm', 'description'],
                sharedWith: [],
                isGenerating: false,
                currentLink: '',
                viewedLink: null,
                isDescriptionVisible: true,
                isAttachmentsVisible: true,
                isMetaFormVisible: true,
                isActivitiesVisible: true,
                isApprover: false,
                category: null,
                currentDepartment: null,
                viewedMetaData: null,
            }
        },


        computed: {
            ...mapGetters(['user', 'getSystemLanguage', 'getCurrentCategory', 'getCurrentDepartment']),

            isUserApprover() {
                var isApprover = false;
                if (this.viewedSectionObject != null && this.viewedSectionObject.get('approvers') != null) {
                    for (let i = 0; i < this.viewedSectionObject.get('approvers').length; i++) {
                        const approver = this.viewedSectionObject.get('approvers')[i];
                        if (approver != null && this.user != null && approver.id == this.user.id) {
                            isApprover = true;
                            break
                        }
                    }
                }
                return isApprover;
            },

            getCategory() {
                return this.category || this.getCurrentCategory
            },

            getDirection() {
                if (this.selectedLang == 'english') return 'ltr'
                else return 'rtl'
            },

            getInformationLabel() {
                if (this.viewedSectionObject) {
                    if (this.section == 'article') {
                        if (this.selectedLang == 'english') return 'ARTICLE DETAILS'
                        if (this.selectedLang == 'pashto') return 'د مقالی معلومات'
                        if (this.selectedLang == 'dari') return 'معلومات مقاله'
                    } else if (this.section == 'file') {
                        if (this.selectedLang == 'english') return 'FILE DETAILS'
                        if (this.selectedLang == 'pashto') return 'د دوتنی معلومات'
                        if (this.selectedLang == 'dari') return 'معلومات فایل'
                    }
                    else if (this.section == 'map') {
                        if (this.selectedLang == 'english') return 'MAP DETAILS'
                        if (this.selectedLang == 'pashto') return 'د نقشی معلومات'
                        if (this.selectedLang == 'dari') return 'معلومات نقشه'
                    }
                }
            },

            getDateLabel() {
                if (this.viewedSectionObject) {
                    if (this.selectedLang == 'english') return 'PUBLISHED AT'
                    if (this.selectedLang == 'pashto') return 'خپور شوی په'
                    if (this.selectedLang == 'dari') return 'منتشر شده در'

                }
            },
            getMetaDataLabel() {
                if (this.viewedSectionObject) {
                    if (this.selectedLang == 'english') return 'META DATA'
                    if (this.selectedLang == 'pashto') return 'جانبی معلومات'
                    if (this.selectedLang == 'dari') return 'معلومات جانبی'

                }
            },

            getApprovalByLabel() {
                if (this.viewedSectionObject) {
                    if (this.selectedLang == 'english') return 'APPROVAL BY'
                    if (this.selectedLang == 'pashto') return 'تایید کوونکی'
                    if (this.selectedLang == 'dari') return 'تایید کننده'

                }
            },

            getDescription() {
                if (this.selectedLang == 'dari' && this.viewedSectionObject.get('languages').includes('dari')) return this.viewedSectionObject.get('description_dari')
                else if (this.selectedLang == 'pashto' && this.viewedSectionObject.get('languages').includes('pashto')) return this.viewedSectionObject.get('description_pashto')
                else if (this.selectedLang == 'english' && this.viewedSectionObject.get('languages').includes('english')) return this.viewedSectionObject.get('description_english')
            },

            getArticleStatus() {
                return this.viewedSectionObject.get('status')
            },

            getUploader() {
                if (this.viewedSectionObject) {
                    return this.viewedSectionObject.uploadedBy.name
                }
            },

            showApprovalBtns() {
                if (this.viewedSectionObject) {
                    if ((this.user.get('roles').includes('articleApprover') || this.user.get('roles').includes('articleContentManager')) && this.viewedSectionObject.status == 'pending') {
                        return true
                    }
                } else return false
            },


            getProgressText() {
                return this.progressText;
            },


            checkFileType() {
                if (this.viewedSectionObject) {
                    if (this.viewedSectionObject.mime.includes('image')) return 'image'
                    else if (this.viewedSectionObject.mime.includes('video')) return 'video'
                    else if (this.viewedSectionObject.mime.includes('pdf')) return 'pdf'
                    else if (this.viewedSectionObject.mime.includes('audio')) return 'audio'
                    else if (this.viewedSectionObject.mime.includes('zip')) return 'zip'
                }
            },

            getFileUrl() {
                return this.viewedSectionObject.attachment.url
            },

            getLabel() {
                if (this.viewedSectionObject == null) return "n/a";
                if (this.selectedLang == "dari") {
                    if (this.viewedSectionObject.get("label_dari") != "") return this.viewedSectionObject.get("label_dari");
                    else if (this.viewedSectionObject.get("label_pashto") != "") return this.viewedSectionObject.get("label_pashto");
                    else return this.viewedSectionObject.get("label_english");
                }


                else if (this.selectedLang == "pashto") {
                    if (this.viewedSectionObject.get("label_pashto") != "") return this.viewedSectionObject.get("label_pashto");
                    else if (this.viewedSectionObject.get("label_dari") != "") return this.viewedSectionObject.get("label_dari");
                    else return this.viewedSectionObject.get("label_english");
                }
                else if (this.selectedLang == "english") {
                    if (this.viewedSectionObject.get("label_english") != "") return this.viewedSectionObject.get("label_english");
                    else if (this.viewedSectionObject.get("label_pashto") != "") return this.viewedSectionObject.get("label_pashto");
                    else return this.viewedSectionObject.get("label_dari");
                }
            },
        },

        watch: {
            selectedLinkParts(val) {
                if (this.selectedLinkParts.length == 0) this.selectedLinkParts = ['description']
            },

            async '$route'(v) {
                await this.fetchings()
            }
        },

        methods: {
            ...mapActions(['sendNewNotification', 'setSystemLanguage']),

            async updateShareWith() {
                if (this.viewedSectionObject) {
                    this.viewedSectionObject.set('shared_with', this.sharedWith.map(guest => guest.user))
                    this.viewedSectionObject.save().then(async res => {
                        if (this.sharedWith != null && res.get('status') == 'approved') {
                            await this.sharedWith.forEach(async guest => {
                                if (guest.isPrev == false) {
                                    await this.g_newActivity({
                                        label_english: res.get('label_english'),
                                        label_pashto: res.get('label_pashto'),
                                        label_dari: res.get('label_dari'),
                                        type: this.section,
                                        action: 'shareWithGuest',
                                        url: this.$route.path,
                                        createdBy: this.user.id,
                                        to: guest.user,
                                        category: this.getCategory,
                                        department: this.currentDepartment,
                                        class: this.sectionCapitalized,
                                        reference_id: this.viewedSectionObject.id
                                    })
                                }
                            })
                        }
                        this.$notify({
                            group: 'foo',
                            text: this._(this.sectionCapitalized + ' was updated'),
                            duration: 4000,
                            position: 'top left',
                            type: 'success'
                        });
                    }).catch(e => {
                        this.$notify({
                            group: 'foo',
                            title: this._('System error'),
                            text: this._('Error while updating'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });
                    })
                }
            },


            async copyLinkToClipboard() {
                let testingCodeToCopy = document.querySelector('#generatedLink')
                testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
                testingCodeToCopy.select()

                try {
                    var successful = document.execCommand('copy');

                } catch (err) {
                    alert('Oops, unable to copy');
                }

                /* unselect the range */
                // testingCodeToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },

            openGenerateLink() {
                this.$refs.generateLinkModal.open()
            },

            async generateLink() {
                if (!this.isGenerating && !this.viewedLink) {
                    this.$store.commit('setLoading', true)
                    let Link = Parse.Object.extend('Link')
                    let newLink = new Link()

                    await newLink.save({
                        theId: this.$route.params.id,
                        class: this.sectionCapitalized,
                        description: this.selectedLinkParts.includes('description'),
                        attachments: this.selectedLinkParts.includes('attachments'),
                        meta_form: this.selectedLinkParts.includes('metaForm'),
                        category: this.getCategory,
                        department: this.currentDepartment,
                    }).then(async res => {

                        res.set('link', 'https://neis.nepa.gov.af/public/' + res.id)
                        await res.save()
                        this.viewedLink = res
                        this.currentLink = res.get('link')
                        this.viewedSectionObject.set('public_link', res)
                        await this.viewedSectionObject.save()

                        await this.g_newActivity({
                            label_english: this.viewedSectionObject.get('label_english'),
                            label_pashto: this.viewedSectionObject.get('label_pashto'),
                            label_dari: this.viewedSectionObject.get('label_dari'),
                            type: this.section,
                            action: this.section + 'PublicShare',
                            url: this.$route.path,
                            to: null,
                            category: this.getCategory,
                            department: this.currentDepartment,
                            class: this.sectionCapitalized,
                            reference_id: this.viewedSectionObject.id
                        })


                        this.$store.commit('setLoading', false)
                        this.$notify({
                            group: 'foo',
                            text: this._(this.sectionCapitalized + ' link was generated'),
                            duration: 4000,
                            position: 'top left',
                            type: 'success'
                        });
                    }).catch(e => {
                        this.$store.commit('setLoading', false)
                        this.$notify({
                            group: 'foo',
                            text: this._('An error accured while generating ' + this.section + ' link'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });
                    })
                }
            },



            async confirmLink() {
                this.$store.commit('setLoading', true)
                this.$refs.generateLinkModal.close()

                if (this.isGenerating == false) {
                    this.viewedLink.destroy()
                        .then(async res => {
                            this.viewedLink = null
                            this.selectedLinkParts = ['attachments', 'metaForm', 'description']
                            this.currentLink = ''
                            this.$refs.generateLinkModal.close()
                            this.$store.commit('setLoading', false)
                            this.viewedSectionObject.set('public_link', null)
                            await this.viewedSectionObject.save()

                            await this.g_newActivity({
                                label_english: this.viewedSectionObject.get('label_english'),
                                label_pashto: this.viewedSectionObject.get('label_pashto'),
                                label_dari: this.viewedSectionObject.get('label_dari'),
                                type: this.section,
                                action: this.section + 'UpdatePublicShareLink',
                                url: this.$route.path,
                                to: null,
                                category: this.getCategory,
                                department: this.currentDepartment,
                                class: this.sectionCapitalized,
                                reference_id: this.viewedSectionObject.id
                            })

                            this.$notify({
                                group: 'foo',
                                text: this._('Public link was deleted'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            });
                        }).catch(e => {
                            this.$notify({
                                group: 'foo',
                                text: this._('An error accured while deleting public link'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        })
                } else {

                    this.viewedLink.set('attachments', this.selectedLinkParts.includes('attachments'))
                    this.viewedLink.set('meta_form', this.selectedLinkParts.includes('metaForm'))
                    this.viewedLink.set('description', this.selectedLinkParts.includes('description'))


                    await this.viewedLink.save()
                        .then(async res => {
                            await this.g_newActivity({
                                label_english: this.viewedSectionObject.get('label_english'),
                                label_pashto: this.viewedSectionObject.get('label_pashto'),
                                label_dari: this.viewedSectionObject.get('label_dari'),
                                type: this.section,
                                action: this.section + 'UpdatePublicShareLink',
                                url: this.$route.path,
                                to: null,
                                category: this.getCategory,
                                department: this.currentDepartment,
                                class: this.sectionCapitalized,
                                reference_id: this.viewedSectionObject.id
                            })
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._(this.sectionCapitalized + ' link was updated'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                        }).catch(e => {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('An error accured while generating ' + this.section + ' link'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        })
                }
            },

            getFileMainType(filename) {

                switch (filename.substr(filename.search(/(\.)(?!.*\.)/) + 1)) {
                    case 'mp4': return 'video'
                    case 'mpg': return 'video'
                    case 'avi': return 'video'
                    case 'mpeg': return 'video'
                    case 'mkv': return 'video'
                    case '3gp': return 'video'
                    case 'm4a': return 'video'
                    case 'wmv': return 'video'
                    case 'asf': return 'video'
                    case 'm4a': return 'video'


                    case 'wav': return 'audio'
                    case 'mp3': return 'audio'
                    case 'midi': return 'audio'
                    case 'jpg': return 'image'
                    case 'jpeg': return 'image'
                    case 'bmp': return 'image'
                    case 'png': return 'image'
                    case 'tiff': return 'image'
                    case 'gif': return 'image'
                    case 'ico': return 'image'
                    case 'pdf': return 'pdf'
                    case 'zip': return 'archive'
                }

                return 'alt'
            },

            // approved
            approveObject() {
                this.g_approveObject(this.viewedSectionObject)
                    .then(result => {
                        this.viewedSectionObject = result
                        this.articleKey = Date.now()

                    }).catch(e => {

                    })
            },

            rejectObject() {
                this.g_rejectObject(this.viewedSectionObject)
                    .then(result => {
                        this.viewedSectionObject = result
                        this.articleKey = Date.now()
                    }).catch(e => {

                    })
            },

            navigate(route) {
                let routeData = this.$router.resolve(route)
                window.open(routeData.href, '_blank');
            },



            // pending
            getFieldLabel(names) {
                if (this.selectedLang == 'dari' && names.dari != '') return names.dari
                else if (this.selectedLang == 'pashto' && names.pashto != '') return names.pashto
                else return names.english

            },

            getValue(prop) {
                // 
                if (prop.value instanceof Date) {
                    return new Date(prop.value).getFullYear() +
                        '-' + (parseInt(new Date(prop.value).getMonth()) + parseInt(1)) + '-' +
                        new
                            Date(prop.value).getDate()
                } else if (prop.type == 'select' || prop.type == 'single-option' || prop.type == 'multiple-option') {
                    if (!Array.isArray(prop.value)) prop.value = [prop.value]
                    // 
                    var ret = []
                    for (var f in this.fields) {
                        if (this.fields[f].key == prop.key) {
                            if (this.fields[f].type == 'select' || this.fields[f].type == 'multiple-option' || this.fields[
                                f].type == 'single-option') {
                                // 
                                for (var d in this.fields[f].options) {
                                    for (const key in prop.value) {
                                        // 
                                        if (prop.value[key] == this.fields[f].options[d].value) {
                                            // ret.push(this.fields[f].options[d].label)
                                            if (this.selectedLang == 'dari') ret.push(this.fields[f].options[d].dariLabel)
                                            else if (this.selectedLang == 'pashto') ret.push(this.fields[f].options[d].pashtoLabel)
                                            else ret.push(this.fields[f].options[d].englishLabel)
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // 
                    return ret.join(', ')
                } else if (prop.type == 'createdBy') {
                    return prop.value.name
                } else if (prop.type == 'checkbox') {
                    if (this.selectedLang == 'english') {
                        if (prop.value) return 'Yes'
                        else return 'No'
                    } else if (this.selectedLang == 'pashto') {
                        if (prop.value) return 'هو'
                        else return 'نه'
                    } else if (this.selectedLang == 'dari') {
                        if (prop.value) return 'بلی'
                        else return 'نخیر'
                    }
                } else {
                    return prop.value
                }
            },

            getFileName(file) {
                return file.split('/')[file.split('/').length - 1]
            },


            async fetchMetaForm(sectionObject) {
                let metaFormLayout = await this.viewedSectionObject.get('meta_form_layout').fetch()
                if (metaFormLayout && metaFormLayout.get('class_name')) {
                    let q = new Parse.Query(metaFormLayout.get('class_name'))
                    q.equalTo('objectId', sectionObject.get('meta_data_id'))
                    var meta_date = await q.first()
                    this.viewedMetaData = meta_date

                    let fields = [];
                    if (metaFormLayout.get('layout')) {
                        metaFormLayout.get('layout').map(q => {
                            if (q.type !== 'heading' && q.type !== 'description') {
                                fields.push({
                                    key: q.fieldDatabaseName,
                                    label: {
                                        english: metaFormLayout.get('form_languages').includes(
                                            'english') ? q.englishLabel : '',
                                        pashto: metaFormLayout.get('form_languages').includes(
                                            'pashto') ? q.pashtoLabel : '',
                                        dari: metaFormLayout.get('form_languages').includes(
                                            'dari') ? q.dariLabel : ''
                                    },
                                    type: q.type,
                                    options: q.type == 'multiple-option' || q.type ==
                                        'single-option' || q.type == 'select' ? q.options : []
                                })
                            }
                        });
                    }

                    if (meta_date)
                        for (var index in fields) {
                            if (fields[index].type == 'single-geolocation') {
                                this.meta_data_props.push({
                                    name: fields[index].label,
                                    value: { lat: meta_date.get('latitude'), lng: meta_date.get('longitude') },
                                    type: fields[index].type,
                                    key: fields[index].key
                                })

                            } else {
                                this.meta_data_props.push({
                                    name: fields[index].label,
                                    value: meta_date.get(fields[index].key),
                                    type: fields[index].type,
                                    key: fields[index].key
                                })
                            }
                        }

                    this.fields = fields

                }
            },

            async fetchings() {
                this.$store.commit("setLoading", true);

                this.selectedLang = this.getSystemLanguage
                this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
                this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment

                if (this.$route.meta.isPublicView) {
                    if (this.$route.params.id) this.viewedLink = await this.g_fetchObject(this.$route.params.id, 'Link')
                    this.isGenerating = true
                    this.currentLink = this.viewedLink.get('link')

                    let temp = []

                    if (this.viewedLink.get('attachments') == true) {
                        temp.push('attachments')

                    } else this.isAttachmentsVisible = false
                    if (this.viewedLink.get('description') == true) {
                        temp.push('description')

                    } else this.isDescriptionVisible = false
                    if (this.viewedLink.get('meta_form') == true) {
                        temp.push('metaForm')
                        this.isMetaFormVisible = true
                    } else this.isMetaFormVisible = false

                    this.selectedLinkParts = temp
                    this.viewedSectionObject = await this.g_fetchObject(this.viewedLink.get('theId'), this.viewedLink.get('class'))
                    this.section = this.viewedLink.get('class').toLowerCase()
                    this.sectionCapitalized = this.viewedLink.get('class')



                } else {

                    if (this.$route.params.id) this.viewedSectionObject = await this.g_fetchObject(this.$route.params.id, this.sectionCapitalized)

                    if (this.viewedSectionObject.get('shared_with') != null) {
                        this.sharedWith = this.viewedSectionObject.get('shared_with').map(guest => {
                            return { user: guest, isPrev: true, hasSubmission: false }
                        })
                    }

                    if (this.viewedSectionObject.get('approvers')) {
                        this.viewedSectionObject.get('approvers').forEach(user => {
                            if (user.id == this.user.id) this.isApprover = true
                        })
                    }

                    if (this.viewedSectionObject.get('public_link')) {
                        this.viewedLink = await this.viewedSectionObject.get('public_link').fetch()
                        this.isGenerating = true
                        this.currentLink = this.viewedSectionObject.get('public_link').get('link')

                        let temp = []

                        if (this.viewedLink.get('attachments') == true) temp.push('attachments')
                        if (this.viewedLink.get('description') == true) temp.push('description')
                        if (this.viewedLink.get('meta_form') == true) {

                            temp.push('metaForm')
                        }

                        this.selectedLinkParts = temp
                    }
                }

                if (this.viewedSectionObject && this.viewedSectionObject.get('meta_form_layout') && this.viewedSectionObject.get('meta_data_id'))
                    await this.fetchMetaForm(this.viewedSectionObject)
                this.$store.commit("setLoading", false);
            }
        },

        async mounted() {
            await this.fetchings()
        }
    }
</script>

<style scoped>
    .article_form {
        /* border-left: 1px solid #dadada; */
    }

    .field_label {
        padding-bottom: 1px;
        padding-top: 8px;
    }

    .file_chip_preview {
        margin: 5px 0;
        white-space: nowrap;
        border: 1px solid gray;
        border-radius: 3px;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0px 4px;
        text-decoration: none;
        color: black
    }

    .file_view:hover {
        color: gray;
        cursor: pointer;
    }

    .file_view {
        margin: 5px 0;
        white-space: nowrap;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0px 4px;
        text-decoration: none;
    }

    .file_download {
        margin-top: 5px;
        color: gray !important;
        text-decoration: none
    }

    .file_download_icon:hover {
        color: black !important
    }

    .file_hover:hover {
        opacity: .8;
        background: gray;
        cursor: pointer;
    }

    .copy_link {
        border: 1px solid;
        padding: 5px !important
    }

    .copy_link:hover {
        border: 1px solid;
        color: black !important
    }

    .public_link {
        display: flex;
        align-items: center;
        margin-top: 20px
    }
</style>